import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

export const useSiteSettings = () => {
  const [monthlyPot, setMonthlyPot] = useState<number>(20000);
  const [totalGivenAway, setTotalGivenAway] = useState<number>(390000);
  const [leaderboardStartDate, setLeaderboardStartDate] = useState<string>("");
  const [leaderboardEndDate, setLeaderboardEndDate] = useState<string>("");
  const [loading, setLoading] = useState(true);

  const fetchSettings = async () => {
    const { data, error } = await supabase
      .from('site_settings')
      .select('key, value');
    
    if (!error && data) {
      data.forEach(setting => {
        if (setting.key === 'monthly_pot') {
          setMonthlyPot(Number(setting.value));
        } else if (setting.key === 'total_given_away') {
          setTotalGivenAway(Number(setting.value));
        } else if (setting.key === 'leaderboard_start_date') {
          setLeaderboardStartDate(setting.value);
        } else if (setting.key === 'leaderboard_end_date') {
          setLeaderboardEndDate(setting.value);
        }
      });
    }
    setLoading(false);
  };

  const updateSetting = async (key: string, value: number | string) => {
    const { data: { user } } = await supabase.auth.getUser();
    
    const { error } = await supabase
      .from('site_settings')
      .update({ value: value.toString(), updated_at: new Date().toISOString(), updated_by: user?.id })
      .eq('key', key);
    
    if (!error) {
      if (key === 'monthly_pot') setMonthlyPot(value as number);
      else if (key === 'total_given_away') setTotalGivenAway(value as number);
      else if (key === 'leaderboard_start_date') setLeaderboardStartDate(value as string);
      else if (key === 'leaderboard_end_date') setLeaderboardEndDate(value as string);
      return true;
    }
    return false;
  };

  useEffect(() => {
    fetchSettings();
  }, []);

  return {
    monthlyPot,
    totalGivenAway,
    leaderboardStartDate,
    leaderboardEndDate,
    loading,
    updateSetting,
    refetch: fetchSettings
  };
};
